import React, { FC, useState, useEffect } from 'react';
import {
    PrimaryButton,
    Icon,
    MessageBar,
    MessageBarType,
} from '@fluentui/react';
import {
    Dialog,
    TextField,
} from '@eta/components';
import { useTranslation } from 'react-i18next';
import { ConnectedProps, connect } from 'react-redux';
import { ReduxState } from '../../../common/reducers';
import { DelegetesStatusUpdateDto, DelegeteStatusUpdateDto, ProfileStatus, GetRepresentationOfTaxpayerDto, UserRoles } from '../../../Services/ClientProxy/clientProxy';
import { StatusCodes } from '../../../common/config/constants';

export interface BlockUserProps {
    hidden: boolean;
    onClose: () => void;
    onSave: (request: DelegetesStatusUpdateDto) => void;
    UserData: GetRepresentationOfTaxpayerDto | undefined;
}

const mapStateToProps = (state: ReduxState) => ({
    lastError: state.taxpayerProfile.lastError,
});

const mapDispatchToProps = {
};

const connector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;

const BlockUser: FC<PropsFromRedux & BlockUserProps> = (
    props: PropsFromRedux & BlockUserProps
) => {
    const { t } = useTranslation(['resources']);
    const { hidden, lastError, onClose, UserData, onSave } = props;
    const [Reason, setReason] = useState<string>('');
    const [error, setError] = useState<string>();

    const handleChangeStatusClick = async (status: ProfileStatus) => {
        const reason = Reason?.trim().length;
        if (reason && reason <= 200) {
            const request = new DelegetesStatusUpdateDto({
                delegeteStatusDto: [
                    new DelegeteStatusUpdateDto({
                        representationID: UserData?.taxpayerRepresentationID ?? 0,
                        status,
                        reason: Reason.trim(),
                        activeFrom: undefined,
                        activeTo: undefined,
                        allBranches: undefined,
                        claims: undefined,
                        restrictedBranch: undefined,
                        role: UserData?.role as unknown as UserRoles,
                    })]
            });
            onSave(request);
        } else
            setError(t('form.actions.ValidReasonRequired'));
    };

    useEffect(() => {
        setError(lastError?.serviceError?.toString());
    }, [lastError]);

    useEffect(() => {
        if (!hidden) {
            setReason('');
            setError('');
        }
    }, [hidden]);

    const closeDialog = () => {
        onClose();
    };

    const isActive = () => {
        return (UserData?.status?.toString() === StatusCodes.Active?.toString());
    };

    return (
        <Dialog
            hidden={hidden}
            onDismiss={() => {
                closeDialog();
            }}
            maxWidth={450}
            title={(
                <>
                    <Icon iconName="Block" />{' '} {isActive() ? t('form.actions.blockUser') : t('form.actions.UnblockUser')}
                </>
            )}
        >
            <div>
                <div>
                    {error && (
                        <div className="errorMessage">
                            <MessageBar
                                messageBarType={MessageBarType.error}
                                isMultiline={false}
                                onDismiss={() => setError('')}
                                truncated
                            >
                                {error}
                            </MessageBar>
                        </div>
                    )}

                    {isActive() ? (
                        <>
                            <div className="bodyLine">
                                <div>
                                    <p>{t('form.Block.sureblockUser')}</p>
                                    <p> </p>
                                    <p>{t('form.Block.blockUserreason')}</p>

                                </div>
                            </div>
                            <div className="bodyLine">
                                <TextField
                                    value={Reason}
                                    onChange={(_, v) => setReason(v ?? '')}
                                    autoFocus
                                    placeholder={t('form.Block.reason')}
                                />
                            </div>
                            <div className="bodyLine">
                                <br />
                                <PrimaryButton
                                    className="Register"
                                    onClick={() => handleChangeStatusClick(ProfileStatus.Blocked)}
                                    disabled={(Reason?.length ?? 0) < 1}
                                >
                                    {t('form.actions.block')}
                                </PrimaryButton>
                            </div>
                        </>
                    ) : (
                            <>
                                <div className="bodyLine">
                                    <div>
                                        <p>{t('form.UnBlock.sureunblockUser')}</p>
                                        <p> </p>
                                        <p>{t('form.UnBlock.unblockUser')}</p>

                                    </div>
                                </div>
                                <div className="bodyLine">
                                    <TextField
                                        value={Reason}
                                        onChange={(_, v) => setReason(v ?? '')}
                                        autoFocus
                                        placeholder={t('form.Block.reason')}
                                    />
                                </div>
                                <div className="bodyLine">
                                    <br />
                                    <PrimaryButton
                                        className="Register"
                                        onClick={() => handleChangeStatusClick(ProfileStatus.Active)}
                                        disabled={(Reason?.trim().length ?? 0) < 1}
                                    >
                                        {t('form.actions.unblock')}
                                    </PrimaryButton>
                                </div>
                            </>
                        )}
                </div>
            </div>
        </Dialog>
    );
};

export default connector(BlockUser);
